export default __webpack_public_path__ + "01f5c6bf6af49512db4cd271749b821e.png";